// Get the API URL - use relative path in production, env variable in development
export const getApiUrl = () => {
  // In production, use relative URL (same origin)
  if (process.env.NODE_ENV === 'production') {
    return '';  // Empty string means same origin
  }
  // In development, use the env variable
  return process.env.REACT_APP_BACKEND_URL || '';
};

export const API_URL = getApiUrl();

// Get the full backend URL (needed for image URLs that redirect to S3)
export const getBackendUrl = () => {
  // In preview (emergentagent.com), use the env variable
  // In production (nextgig.shop), use relative path
  const backendUrl = process.env.REACT_APP_BACKEND_URL || '';
  return backendUrl;
};

// Helper to construct proper image URL
// This ensures images work in both preview and production
export const getImageUrl = (url, fallback = 'https://images.unsplash.com/photo-1563841930606-67e2bce48b78?auto=format&fit=crop&q=80&w=800') => {
  if (!url) return fallback;
  
  // If it's already a full URL (http/https), return as-is
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }
  
  // If it's an API path (/api/files/ or /api/uploads/), prepend the backend URL
  if (url.startsWith('/api')) {
    const backendUrl = getBackendUrl();
    // In production mode with same domain, backendUrl might be empty - that's fine for relative URLs
    return `${backendUrl}${url}`;
  }
  
  // For any other path, just return as-is (could be a relative path)
  return url;
};